module.exports = __webpack_public_path__ + "static/media/report-icon.bc8bd91b.svg";